import classNames from 'classnames';
import { PATH_SIGNUP_ME } from '@farmersdog/constants/paths';
import {
  Picture,
  Section,
  generateSourcesForPicture,
  type MobileAndDesktopSources,
} from '@farmersdog/corgi-x';
import { getLinkToFreshSignup } from '@farmersdog/tosa/src/utils/getLinkToSignupFlow';
import { useShowHomepageRedesign } from 'src/hooks/useHomepageRedesign';

import { ExtendedButton } from '../../../ExtendedButton';
import { CtaTrackerV2, HomepageRedesignSections } from '../../../CtaTrackerV2';

import styles from './HeroImage.module.css';

type HeroImageProps = {
  sources: MobileAndDesktopSources;
  objectPosition?: React.CSSProperties['objectPosition'];
  showOverlay?: boolean;
};

const ctaLabel = 'Shop Fresh';

export const HeroImage = ({
  sources,
  objectPosition,
  showOverlay = true,
}: HeroImageProps) => {
  const { treatment } = useShowHomepageRedesign();
  const linkToFreshSignup = getLinkToFreshSignup(PATH_SIGNUP_ME);
  const sourcesForPicture = generateSourcesForPicture(sources);

  return (
    <Section as="div" className={classNames(styles.wrapper, styles[treatment])}>
      <div className={classNames(styles.container, styles[treatment])}>
        <Picture
          alt="A dog with a bowl of food"
          className={styles.picture}
          sources={sourcesForPicture}
          style={{ objectPosition }}
        />
        {showOverlay && (
          <div className={styles.overlay}>
            <CtaTrackerV2
              type="select"
              moduleLevel={1}
              moduleName={HomepageRedesignSections.Hero}
            >
              <ExtendedButton
                variant="bordered-white"
                type="link"
                to={linkToFreshSignup}
                className={styles.cta}
              >
                {ctaLabel}
              </ExtendedButton>
            </CtaTrackerV2>
          </div>
        )}
      </div>
    </Section>
  );
};
